import OEmbedPreview from '@/ui/OEmbedPreview'
import {defineType} from 'sanity'

export default defineType({
  type: 'object',
  name: 'oembed',
  title: 'Embed (video, audio, etc)',
  fields: [
    {
      name: 'url',
      type: 'url',
      description: 'The URL of the oembed content (ie YouTube url, Vimeo url, etc)',
    },
  ],
  components: {
    preview: OEmbedPreview,
  },
  preview: {
    select: {url: 'url'},
  },
})
